import { render, staticRenderFns } from "./DinnerIVRCalls.vue?vue&type=template&id=2650ff25&"
import script from "./DinnerIVRCalls.vue?vue&type=script&lang=js&"
export * from "./DinnerIVRCalls.vue?vue&type=script&lang=js&"
import style0 from "./DinnerIVRCalls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports